import type { NavigationMode, NavigationModeContext, NavigationModeKey } from './types';

export class AvatarMode implements NavigationMode {
  readonly key: NavigationModeKey = 'avatar';

  activate(_ctx: NavigationModeContext): void {}

  deactivate(): void {}
}

export class AnimMode implements NavigationMode {
  readonly key: NavigationModeKey = 'anim';

  activate(_ctx: NavigationModeContext): void {}

  deactivate(): void {}
}
